import type { ReactElement } from 'react'

import { ContentContainerBackoffice, Skeleton, spacing, useTranslate } from '@orus.eu/pharaoh'
import { Header } from '@orus.eu/pharaoh/src/patterns/header'

import { StickyHeaderContainer } from '#/components/pages/backoffice/sticky-header-container.tsx'

/** The broker renewal page's frame: its header, the deadline line, the price card and the declaration card. */
export function BackofficePartnerRenewalPageSkeleton(): ReactElement {
  const translate = useTranslate()
  return (
    <>
      <StickyHeaderContainer>
        <Header
          title={translate('contract_version_type_renewal')}
          leftButton={<Skeleton.Button size="small" width={32} />}
          badge={<Skeleton.Badge width={120} />}
        />
      </StickyHeaderContainer>
      <ContentContainerBackoffice marginTop={spacing[60]}>
        <Skeleton.Text size="body2" width={320} />
        <Skeleton.Block height={240} />
        <Skeleton.Block height={320} />
      </ContentContainerBackoffice>
    </>
  )
}
